import React, { useContext, useEffect } from 'react';
import Modal from '../../../../components/Modal/Modal';
import ModalHuellas from '../../../../components/BiometricComponent/ModalHuellas';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { CancelButton, ConfirmationButton } from '../../../../components';
import { Flex } from '@chakra-ui/react';
import BiometricComponent from '../../../../components/BiometricComponent';
import { PoppinsSemiBold } from '../../../../components/Fonts';
import { BiometricContext } from '../../../../utility/context/Biometric';
NiceModal.register('modal-biometrico-huellas', ModalHuellas);

const CapturaBiometrico = ({ label, initialDedos }) => {
	const modal = useModal();
	const { biometricsState, setBiometricsState } = useContext(BiometricContext);
	const handleSubmit = () => {
		modal.resolve([...biometricsState]);
		modal.hide();
	};
	const handleCancel = () => {
		modal.reject(null);
		modal.hide();
	};

	useEffect(() => {
		setBiometricsState([]);
	}, []);

	return (
		<Modal title="Selección de huellas" size="xl">
			<ModalBody>
				<Flex direction="column">
					<Flex wrap="wrap" alignItems="center" justifyContent="space-evenly">
						<PoppinsSemiBold sx="18px" color="#363B4D">
							{label || 'Selecciona las huellas a confrontar'}
						</PoppinsSemiBold>
					</Flex>
				</Flex>
				<BiometricComponent initialDedos={initialDedos} />
			</ModalBody>
			<ModalFooter className="modal-footer-buttons">
				<CancelButton onClick={handleCancel} label="Cancelar" />
				<ConfirmationButton
					onClick={handleSubmit}
					label="Buscar"
					//todo habilitar al momento que se agregue funcionalidad de biometricos
					//disabled={!biometricsState?.length}
				/>
			</ModalFooter>
		</Modal>
	);
};

export default NiceModal.create(CapturaBiometrico);
